<template>
  <div class="hidden-lg-and-up" style="overflow: hidden">
    <v-stepper :value.sync="e1">
      <v-stepper-items>
        <v-stepper-content :step="1" class="pa-0">
          <div class="body__container">
            <div class="d-flex justify-space-between">
              <div style="display: flex; align-items: center">
                <img
                  src="./../../../assets/font/logo.png"
                  alt=""
                  width="150px"
                  height="37px"
                />
              </div>
              <div class="text-xs-right">
                <v-btn-toggle v-model="$i18n.locale" dark mandatory>
                  <v-btn text :value="'th'" style="font-size: 0.8em">TH</v-btn>
                  <v-btn text :value="'en'" style="font-size: 0.8em">EN</v-btn>
                </v-btn-toggle>
              </div>
            </div>
            <v-form v-model="valid" ref="form">
              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <div class="body__title">
                      {{
                        $i18n.locale == "th"
                          ? "กรอกข้อมูลธุรกิจ"
                          : "Business Information"
                      }}
                    </div>
                    <div class="content__subtitle pt-1">
                      {{
                        $i18n.locale == "th"
                          ? "กรอกรายละเอียดสำคัญพร้อมแนบเอกสาร"
                          : "Fill out important details and attach documents."
                      }}
                    </div>
                    <a
                      style="color: #3fa9f5"
                      target="blank"
                      href="https://storage.googleapis.com/image-weserve/file/contract_weserve_partner_2020.pdf"
                      >{{
                        $i18n.locale == "th"
                          ? "คลิกเพื่อดาวโหลดเอกสารสัญญา"
                          : "Click to download contract document."
                      }}</a
                    >
                  </v-flex>
                  <v-flex xs12>
                    <div class="content__subtitle">
                      {{
                        $i18n.locale == "th" ? "ชื่อร้าน " : "Your store name: "
                      }}
                      {{ storeName.store_name_th }}
                    </div>
                    <v-radio-group
                      v-model="formStoreBank.store_bank_type"
                      row
                      hide-details
                    >
                      <v-radio
                        color="black"
                        :label="
                          $i18n.locale == 'th' ? 'บุคคลทั่วไป' : 'General'
                        "
                        :value="2"
                      ></v-radio>
                      <v-radio
                        color="black"
                        :label="
                          $i18n.locale == 'th' ? 'นิติบุคคล' : 'Corporation'
                        "
                        :value="1"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12>
                    <div class="d-flex align-center justify-space-between">
                      <div>
                        <div class="content__title">
                          {{
                            $i18n.locale == "th"
                              ? "เอกสารประกอบธุรกิจ"
                              : "Business document"
                          }}
                        </div>
                        <div
                          class="content__subtitle pt-1"
                          v-if="formStoreBank.store_bank_type === 1"
                        >
                          <div>
                            {{
                              $i18n.locale == "th"
                                ? "1. หนังสือรับรองนิติบุคคล, ภพ.20 (ถ้ามี)"
                                : "1. Copy of company registration certificate, Por po 20 (if any)"
                            }}
                          </div>
                          <div>
                            {{
                              $i18n.locale == "th"
                                ? "2. สำเนาเอกสารสัญญาใช้บริการแพลตฟอร์ม (กรอกรายละเอียด เฉพาะหน้า 1-3)"
                                : "2. Service platform for seller contract (page 1 to 3)"
                            }}
                          </div>
                        </div>
                        <div class="content__subtitle pt-1" v-else>
                          <div>
                            {{
                              $i18n.locale == "th"
                                ? "1. สำเนาบัตรประชาชน"
                                : "1. Copy of ID Card"
                            }}
                          </div>
                          <div>
                            {{
                              $i18n.locale == "th"
                                ? "2. สำเนาเอกสารสัญญาใช้บริการแพลตฟอร์ม (กรอกรายละเอียด เฉพาะหน้า 1-3)"
                                : "2. Service platform for seller contract (page 1 to 3)"
                            }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="pt-1">
                      <v-badge
                        color="red"
                        overlap
                        :value="formBizImage.store_business_images.length > 0"
                      >
                        <template v-slot:badge>
                          <div>
                            {{ formBizImage.store_business_images.length }}
                          </div>
                        </template>
                        <v-btn dark @click="openBizImgDialog()">
                          {{
                            $i18n.locale == "th"
                              ? "อัพโหลดรูปภาพ"
                              : "Upload image"
                          }}
                          ( .jpg )</v-btn
                        >
                      </v-badge>
                    </div>

                    <div class="d-flex align-center justify-space-between pt-5">
                      <div>
                        <div class="content__title">
                          {{
                            $i18n.locale == "th"
                              ? "สำเนาหน้าบัญชี"
                              : "Copy of account page"
                          }}
                          <span style="color: red">*</span>
                        </div>
                        <div class="content__subtitle pt-1">
                          {{
                            $i18n.locale == "th"
                              ? "สำเนาบัญชีธนาคาร"
                              : "Copy of bank account"
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="pt-1 d-flex">
                      <v-btn
                        color="#fde10a"
                        light
                        @click="$refs.onUploadBankIMG.click()"
                      >
                        <v-icon
                          color="green"
                          class="mr-1"
                          v-if="formStoreBank.store_bank_image !== null"
                          >check</v-icon
                        >
                        <!-- <v-icon color="red" class="mr-1" v-else>close</v-icon
                    > -->
                        {{
                          $i18n.locale == "th"
                            ? "อัพโหลดรูปภาพ"
                            : "Upload image"
                        }}
                        ( .jpg )</v-btn
                      >
                      <input
                        type="file"
                        @change="OnBankImageSelected($event)"
                        ref="onUploadBankIMG"
                        style="display: none"
                      />
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <div>
                      <v-text-field
                        type="number"
                        :rules="[(v) => !!v || 'required']"
                        v-model="formStoreBank.store_bank_account_number"
                        :label="
                          $i18n.locale == 'th' ? 'เลขบัญชี' : 'Account No.'
                        "
                      ></v-text-field>
                    </div>
                    <div>
                      <v-text-field
                        :rules="[(v) => !!v || 'required']"
                        v-model="formStoreBank.store_bank_account_name"
                        :label="
                          $i18n.locale == 'th' ? 'ชื่อบัญชี' : 'Account name'
                        "
                      ></v-text-field>
                    </div>
                    <div>
                      <v-select
                        v-model="formStoreBank.store_bank_bank_id"
                        :items="thaiBankList"
                        :label="$i18n.locale == 'th' ? 'ธนาคาร' : 'Bank'"
                        :item-text="'thbk_name_' + $i18n.locale"
                        item-value="id"
                        :rules="[(v) => !!v || 'required']"
                      ></v-select>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <div class="d-flex justify-center">
              <v-btn
                light
                @click="submit()"
                :loading="isSubmiting"
                color="#fde10a"
                >{{ $i18n.locale == "en" ? "Submit" : "ยืนยัน" }}</v-btn
              >
            </div>
          </div>
        </v-stepper-content>

        <v-stepper-content :step="2" class="pa-0">
          <div class="body__container">
            <h1 style="padding-top: 100px">
              {{
                $i18n.locale == "th"
                  ? "บริษัทได้รับเอกสารแล้ว"
                  : "The company has received the documents."
              }}
            </h1>
            <div style="font-size: 22px">
              {{
                $i18n.locale == "th"
                  ? "โปรดรออนุมัติภายใน 7 วัน"
                  : "Please wait for approval within 7 days."
              }}
            </div>
            <v-btn
              color="black"
              style="
                position: fixed;
                z-index: 1;
                bottom: 10%;
                left: 50%;
                transform: translate(-50%, -10%);
                color: white;
              "
              @click="goToHomePage()"
              >{{
                $i18n.locale == "th" ? "กลับสู่หน้าหลัก" : "Back to home page"
              }}</v-btn
            >
            <div style="position: fixed; bottom: 0">
              <img src="./../../../assets/bg-error.png" alt="" width="100%" />
            </div>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="visibleBizImgDialog2" persistent fullscreen>
      <v-card
        ><v-card-title class="d-flex justify-space-between">
          <div style="line-height: 2rem">
            <div class="dialog__title">
              {{
                $i18n.locale == "th"
                  ? "เอกสารประกอบธุรกิจ"
                  : "Business document"
              }}
            </div>

            <div
              class="dialog__subtitle"
              v-if="formStoreBank.store_bank_type === 1"
            >
              {{
                $i18n.locale == "th"
                  ? "อัพโหลดรูปภาพเอกสารประกอบธุรกิจแบบย่อและเอกสารสัญญาใช้บริการแพลตฟอร์ม"
                  : "Upload short form business document images and service platform for seller contract images"
              }}
            </div>
            <div class="dialog__subtitle" v-else>
              {{
                $i18n.locale == "th"
                  ? "อัพโหลดรูปภาพสำเนาบัตรประชาชนและรูปภาพเอกสารสัญญาใช้บริการแพลตฟอร์ม"
                  : "Upload copy of ID Card image and service platform for seller contract images"
              }}
            </div>
          </div>
        </v-card-title>
        <v-card-text class="dialog__body">
          <div class="d-flex justify-end">
            <v-btn dark @click="$refs.onUploadBizIMG.click()"
              ><v-icon>add</v-icon
              ><span>{{ $i18n.locale == "en" ? "Add" : "เพิ่ม" }}</span></v-btn
            >
          </div>
          <input
            type="file"
            @change="OnBizImageSelected($event)"
            ref="onUploadBizIMG"
            style="display: none"
          />
          <div
            v-for="(image, index) in formBizImage.store_business_images"
            :key="index"
            class="pt-3"
          >
            <div class="d-flex align-center mb-3">
              <v-img
                :src="image.store_business_image"
                min-width="80px"
                max-width="80px"
                height="80px"
              ></v-img>
              <v-divider vertical class="mx-2"></v-divider>
              <div>
                <div class="dialog__item-title">
                  {{ image.name }}
                </div>
                <div class="dialog__item-subtitle">
                  {{ image.desc ? image.desc : "" }}
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-btn icon @click="removeBizImg(index)"
                ><v-icon color="black">delete</v-icon></v-btn
              >
            </div>
            <v-divider class="my-2"></v-divider>
          </div>
        </v-card-text>
        <v-card-actions
          class="pa-4"
          style="
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            background-color: white;
          "
        >
          <v-spacer></v-spacer>
          <v-btn @click="cancelBizImg()" dark color="red">{{
            $i18n.locale == "en" ? "Cancel" : "ยกเลิก"
          }}</v-btn>
          <v-btn @click="saveBizImg()" dark color="green">{{
            $i18n.locale == "en" ? "Save" : "บันทึก"
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: [
    "bankImage",
    "thaiBankList",
    "formStoreBank",
    "formBizImage",
    "isSubmiting",
    "storeName",
    "e1",
  ],
  data() {
    return {
      show: false,
      visibleBizImgDialog2: false,
      bizImageList: [],
      valid: false,
    };
  },
  computed: {},
  methods: {
    goToHomePage() {
      location.replace("https://weserve.co.th");
    },
    validateImage(file) {
      const isJPG = file.type === "image/jpeg";
      if (!isJPG) {
        this.$emit("openSnackbar", {
          text: "You can only upload JPG file!",
          is_top: false,
        });
      }
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isLt2M) {
        this.$emit("openSnackbar", {
          text: "Image must smaller than 8MB!",
          is_top: false,
        });
      }
      return isJPG && isLt2M;
    },
    submit() {
      if (this.$refs.form.validate() && this.formStoreBank.store_bank_image) {
        this.$emit("submit");
      }
    },
    OnBankImageSelected(event) {
      let file = event.target.files[0];
      if (this.validateImage(file) == true) {
        let reader = new FileReader();
        reader.addEventListener("load", () => {
          this.formStoreBank.store_bank_image = reader.result;
        });
        reader.readAsDataURL(file);
      }
      event.target.value = "";
    },
    OnBizImageSelected(event) {
      let file = event.target.files[0];
      if (this.validateImage(file) == true) {
        let fileName = file.name;
        let fileDesc =
          file.type + " | " + (file.size / 1000).toFixed(2) + " KB";
        let reader = new FileReader();
        reader.addEventListener("load", () => {
          let imgJson = {
            store_business_image: reader.result,
            name: fileName,
            desc: fileDesc,
          };
          this.formBizImage.store_business_images.push(imgJson);
        });
        reader.readAsDataURL(file);
      }
      event.target.value = "";
    },
    openBizImgDialog() {
      this.visibleBizImgDialog2 = true;
      this.bizImageList = JSON.parse(
        JSON.stringify(this.formBizImage.store_business_images)
      );
    },
    cancelBizImg() {
      this.formBizImage.store_business_images = JSON.parse(
        JSON.stringify(this.bizImageList)
      );
      this.bizImageList = new Array();
      this.visibleBizImgDialog2 = false;
    },
    saveBizImg() {
      this.visibleBizImgDialog2 = false;
    },
    addBizImg() {
      this.ImageList.push({
        img: "/bg_1.png",
        name: "asdfkiosadjfiosjafiosjdf",
        desc: "sadnfjsdaiofjsoiafji",
      });
    },
    removeBizImg(index) {
      this.formBizImage.store_business_images.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.body__container {
  background-color: white;
  width: 100%;
  height: 100vh;
  position: relative;
  padding: 20px;
  overflow: auto;
}

.body__title {
  white-space: nowrap;
  font-size: 2em;
  font-weight: bold;
}

.content__title {
  font-size: 1.2em;
  font-weight: bold;
}

.content__subtitle {
  color: grey;
  font-weight: bold;
}

.dialog__title {
  font-size: 2em;
  font-weight: bold;
}
.dialog__subtitle {
  font-size: 1.2em;
  color: grey;
  font-weight: bold;
}

.dialog__item-title {
  font-size: 1.3em;
  color: black;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 200px;
}

.dialog__item-subtitle {
  font-size: 1.1em;
  font-weight: bold;
  color: grey;
  white-space: nowrap;
  overflow: hidden;
  max-width: 300px;
  text-overflow: ellipsis;
}

.dialog__body {
  overflow-y: scroll;
  height: calc(100vh - 200px);
  padding-bottom: 68px !important;
}

.dialog__body::-webkit-scrollbar {
  display: none;
}
</style>